import React, { ButtonHTMLAttributes } from 'react';

import { Container, ButtonProps } from './styles';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  onClick: () => void;
}

const ButtonToggle: React.FC<Props & ButtonProps> = (props) => {
  return (
    <Container
      width={props.width}
      onClick={props.onClick}
      textColor={props.textColor}
      backgroundColor={props.backgroundColor}
      active={props.active}
    >
      {props.children}
    </Container>
  );
};

export { ButtonToggle };
